// intl.ts
import {
  createIntl,
  createIntlCache,
  IntlShape,
  MessageFormatElement,
} from "react-intl";
import { I18n } from "types/config";
import defaultConfig from "config";

const cache = createIntlCache();

function loadLocaleData(i18n: I18n) {
  switch (i18n) {
    case "fr":
      return import("utils/locales_old/fr.json");
    case "ro":
      return import("utils/locales_old/ro.json");
    case "zh":
      return import("utils/locales_old/zh.json");
    case "he":
      return import("utils/locales_old/he.json");
    default:
      return import("utils/locales_old/en.json");
  }
}

const savedConfig = localStorage.getItem("berry-config-vite-ts");
const initialState = savedConfig ? JSON.parse(savedConfig) : defaultConfig;
const i18n = initialState.i18n || "he";

loadLocaleData(i18n).then(
  (d: {
    default:
      | Record<string, string>
      | Record<string, MessageFormatElement[]>
      | undefined;
  }) => {
    intlGlobal = createIntl({ locale: i18n, messages: d.default }, cache);
  }
);
export function setLocale(locale: I18n) {
  loadLocaleData(locale).then(
    (d: {
      default:
        | Record<string, string>
        | Record<string, MessageFormatElement[]>
        | undefined;
    }) => {
      intlGlobal = createIntl({ locale: locale, messages: d.default }, cache);
    }
  );
}

export let intlGlobal: IntlShape;
